import Swiper from 'swiper';
import { FreeMode, Scrollbar } from 'swiper/modules';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';

window.ProductsSlider = (sliderId) => {
    return {
        swiper: null,
        init() {
            setTimeout(() => {
                this.swiper = new Swiper('.' + sliderId, {
                    modules: [FreeMode, Scrollbar],
                    slidesPerView: 'auto',
                    spaceBetween: 32,
                    grabCursor: true,
                    a11y: true,
                    touchEventsTarget: 'container',
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                    scrollbar: {
                        el: '.scrollbar-' + sliderId,
                        draggable: true,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 'auto',
                        },
                        768: {
                            slidesPerView: 'auto',
                        },
                        1024: {
                            slidesPerView: 'auto',
                        },
                    },
                });
            }, 0);
        },
    };
};
